import React, { OptionHTMLAttributes, ReactNode, SelectHTMLAttributes } from 'react';
import classNames from 'classnames';
import SpotIcon from '../Icon/SpotIcon';
import { createSpotClasses, Spot } from '../Spot';

interface SpotSelectBoxProps extends SelectHTMLAttributes<HTMLSelectElement> {
    hidePlaceholder?: boolean;
    placeholder?: string;
}

export function SpotSelectBox({ className, children, placeholder, hidePlaceholder, ...rest }: SpotSelectBoxProps): React.JSX.Element {
    return (
        <div className={classNames(createSpotClasses(Spot.block.form, Spot.element.select), className)}>
            <select className="spot-form__select-input" {...rest}>
                {!hidePlaceholder && <option value={''}>{placeholder ? placeholder : 'Select a value'}</option>}
                {children}
            </select>
            <div className="spot-form__select-inner" />
            <span className="spot-form__select-open-indicator">
                <SpotIcon className="spot-form__select-open-icon" iconName="caret-down" />
            </span>
        </div>
    );
}

export function SpotSelectOption({ className, children, ...rest }: OptionHTMLAttributes<HTMLOptionElement> & { children?: ReactNode }): React.JSX.Element {
    return (
        <option className={[createSpotClasses(Spot.block.form, Spot.element.option), className].join(' ')} {...rest}>
            {children}
        </option>
    );
}
